export const convertKebabCaseToCamelCase = (string: string): string => {
  return (string || '').replace(/(-\w)/g, match => match[1].toUpperCase());
};
